// 权限 API
import Request from '../base'
export default {
  save (options) {
    return Request.post('/eberuser/userapi/user/permission/save', options)
  },
  delete (options) {
    return Request.post('/eberuser/userapi/user/permission/delete', options)
  },
  list (options) {
    return Request.post('/eberuser/userapi/user/permission/list', options)
  },
  hasPermission (permissions) {
    return Request.post('/eberuser/userapi/user/permission/hasPermission', {
      permissions: permissions
    })
  }
}
